import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateCount = createSelector(
  [(store: RootState) => store.templateList.templates],
  (data) => data.length
);
